import TubCommon from "./tubCommon";
import {IS_LIXIL_SERVERS} from "../../../../../config";

export default class ReplacementTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub';
    this.bottomTubId = "replacement_tub";
    this.visible = true;
    this.partName = 'Replacement Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    this.canBeDisabled = IS_LIXIL_SERVERS; // request by Lixil
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }
}
